import React, { useEffect, useRef, useState } from "react";
import Search from "../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import {
  DatePicker,
  Divider,
  Dropdown,
  Form,
  Progress,
  Select,
  Table,
} from "antd";
import svg27 from "../../../assets/svg/svg27.svg";
import svg12 from "../../../assets/svg/svg12.svg";
import svg49 from "../../../assets/svg/svg49.svg";
import svg15 from "../../../assets/svg/svg15.svg";
import svg48 from "../../../assets/svg/svg48.svg";
import svg29 from "../../../assets/svg/svg29.svg";
import BreadCrumb from "../../../layout/BreadCrumb";
import CardLoading from "../../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import { fetchData } from "../../../features/fetch/fetchSlice";
import { setActiveObj } from "../../../features/obj/objSlice";
import { cashConverter, extractYear, formatText } from "../../../utils";
import moment from "moment";
import ConfirmModal from "../../../components/ConfirmModal";
import { save } from "../../../features/save/saveSlice";
import toast from "react-hot-toast";
import svg98 from "../../../assets/svg/svg98.svg";
import AboutProject from "../ongoing/view/AboutProject";
import useModalToggle from "../../../custom_hooks/useModalToggle";

function PlannedProjectsTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const url = "api/v2/main_projects/get";
  const urlScheme = "sch/get_schemes";
  const { loading, data, count, dataScheme } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
    dataScheme: state.fetch.data[urlScheme] || [],
  }));

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");
  const [scheme, setScheme] = useState(null);
  const [yearData, setYearData] = useState(null);

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        projectSchemeId: scheme,
        projectYear: extractYear(yearData),
        projectStatus: "PLANNED",
        projectName: e.target.value == "" ? null : e.target.value,
      })
    );
  };

  const handleEdit = async () => {
    await dispatch(setActiveObj({ key: "plannedProject", data: prodd }));
    await navigate("/planned-project-add");
  };
  const handleDisable = () => {};
  const handleAdd = async () => {
    await dispatch(setActiveObj({ key: "plannedProject", data: {} }));
    await navigate("/planned-project-add");
  };
  const handleView = async () => {
    await dispatch(setActiveObj({ key: "plannedProject", data: prodd }));
    await navigate("/planned-pipeline-details");
  };
  const handleViewName = async (item) => {
    await dispatch(setActiveObj({ key: "plannedProject", data: item }));
    await navigate("/planned-pipeline-details");
  };

  const { open: openAbout, handleOpen: handleOpenAbout, handleCancel: handleCloseAbout } = useModalToggle();

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "api/v2/main_projects/delete",
        projectId: prodd?.projectId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div onClick={handleEdit}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg12} alt="svg12" /> Edit
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={handleOpenDelete}>
          <Link className="flex items-center gap-x-2 actions-text my-2">
            <img src={svg49} alt="svg49" className="w-4 h-4" />
            <span className="whitespace-nowrap">Disable</span>
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <div onClick={handleView}>
          <Link className="flex actions-text items-center  gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg15} alt="svg15"  className="w-4 h-4" />{" "}
            <span className="whitespace-nowrap">Project Details</span>
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "4",
      label: (
        <div onClick={handleOpenAbout}>
          <Link className="flex actions-text items-center gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg98} alt="svg98"  className="w-4 h-4"/>{" "}
            <span className="whitespace-nowrap">View Details</span>
          </Link>
          
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Project Name",
      width:'300px',
      render: (item) => {
        return (
          <div className="cursor-pointer" onClick={() => handleViewName(item)}>
            {item?.projectName}
          </div>
        );
      },
      sorter: (a, b) => a.projectName.localeCompare(b.projectName),
    },
    {
      title: "Pathway",
      dataIndex: "projectPathwayName",
      sorter: (a, b) => a.projectPathwayName.localeCompare(b.projectPathwayName),
    }, 
    {
      title: "Type",
      dataIndex: "projectTypeName",
      sorter: (a, b) => a.projectTypeName.localeCompare(b.projectTypeName),
    },
    {
      title: "Associated Scheme",
      dataIndex: "projectSchemeAssociatedName",
      sorter: (a, b) => a.projectSchemeAssociatedName.localeCompare(b.projectSchemeAssociatedName),
    },
    {
      title: "Implementing Agency",
      dataIndex: "projectAgencyName",
      sorter: (a, b) => a.projectAgencyName.localeCompare(b.projectAgencyName),
    },
    {
      title: "County",
      dataIndex: "projectCountyName",
      sorter: (a, b) => a.projectCountyName.localeCompare(b.projectCountyName),
    },

    {
      title: "Project Estimated Cost",
      dataIndex: "projectCost",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.projectCost.localeCompare(b.projectCost),
    },

    {
      title: "Project Year",
      dataIndex: "projectYear",
      // render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      // sorter: (a, b) =>
      //   moment(a.projectYear).valueOf() -
      //   moment(b.projectYear).valueOf(),
    },
    {
      title: "Status",
      dataIndex: "projectStatus",
      render: (item) => {
       const colors = {
          ONGOING: "#7DACDC",
          PLANNED: "#90A4AE",
          COMPLETED: "#B1E17C",
          STALLED: "#F44336",
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },
    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const onFinish = () => {};

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        projectSchemeId: scheme,
        projectYear: extractYear(yearData),
        projectStatus: "PLANNED",
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    dispatch(
      fetchData({
        url: urlScheme,
        limit: null,
        start: 0,
      })
    );
  }, []);

  useEffect(() => {
    fetchTableData();
  }, [scheme, yearData]);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="lg:min-h-[88vh] flex flex-col">
      <BreadCrumb breadcrumbs={[{ title: "Planned Projects" }]} />
      <div className="flex flex-col w-full  flex-1  white_card mt-[1.25rem]">
        <div className="flex items-center justify-between  gap-y-4">
          <div className="form-add-h">Planned Projects</div>
          <div className="w-[200px]">
            <button onClick={() => handleAdd()} className="cstm-btn-2">
              <img src={svg29} alt="svg29" />
              <span className="ml-1">Plan New Project</span>
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 items-center mt-[3.81rem]">
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            className="contents"
            form={form}
          >
            <div className="flex items-center gap-2 w-full">
              <span className="whitespace-nowrap">Select Scheme</span>
              <Select
                placeholder="Select scheme"
                className="w-full"
                allowClear
                options={
                  dataScheme?.length > 0
                    ? dataScheme?.map((item) => ({
                        value: item?.schId,
                        label: item?.schName,
                      }))
                    : []
                }
                value={scheme}
                onChange={(value) => setScheme(value)}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLowerCase() ?? "").includes(
                    input?.toLowerCase()
                  )
                }
              />
            </div>

            <div className="w-full">
              <DatePicker
                placeholder="Year"
                className="input w-full"
                picker="year"
                value={yearData}
                onChange={(value) => setYearData(value)}
              />
            </div>
          </Form>

          <div className="w-full">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search"}
            />
          </div>
        </div>

        <div className="max-w-full w-full overflow-x-auto">
          <Table
            rowSelection={false}
            className="mt-[1.75rem] w-full"
            scroll={{
              x: 'max-content',
            }}
            rowKey={(record) => record?.projectId}
            columns={columns}
            dataSource={data}
            loading={loading}
            pagination={{
              position: ["bottomRight"],
              current: pageIndex + 1,
              total: count,
              pageSize: pageSize,
              onChange: (page, size) => {
                setPageIndex(page - 1);
                setPageSize(size);
                fetchTableData(page - 1, size);
              },
              showSizeChanger: false,
              hideOnSinglePage: true,
            }}
          />
        </div>
      </div>
      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Delete"
      />
      <AboutProject
        open={openAbout}
        onClose={handleCloseAbout}
        project={prodd}
      />
    </div>
  );
}

export default PlannedProjectsTable;
